module.exports = __webpack_public_path__ + "img/1726038034262-aghnia sasirangan.jpg.2c946a85.webp";